import React from "react"
import styled from "styled-components"

import constants from "~/style/constants"
import FormError from "~/components/Form/ErrorText"

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  ${"" /* &::-webkit-input-placeholder {
   text-align: center;
  } */}
  text-align: center;
  border: none;
  background: white;
  outline: none;
  height: 35px;
  width: 100%;
  max-width: 106px;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  caret-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }

  @media (max-width: 768px) {
    height: 30px;
    font-size: 0.9rem;
    max-width: none;
    flex: 1;
  }

  @media (max-width: 480px) {
    height: 28px;
    font-size: 0.85rem;
  }
`
const RadioLabel = styled.label`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  border-radius: 50%;
  height: 21px;
  width: 21px;
  position: relative;
  background: ${(props) =>
    props.checked ? props.theme.colors.primary : "#E8E8EC"};
  border: 4px solid #e8e8ec;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 768px) {
    height: 18px;
    width: 18px;
    border: 3px solid #e8e8ec;
  }

  @media (max-width: 480px) {
    height: 16px;
    width: 16px;
    border: 2px solid #e8e8ec;
  }
`
const RadioInput = styled.input.attrs({ type: "radio" })`
  border-radius: 50%;
  height: 21px;
  width: 21px;
  background: transparent;
  border: none;
  color: transparent;
  opacity: 0;
  cursor: pointer;
  :checked {
  }
`
const OuterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 70px;
  max-width: 364px;
  width: 100%;
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  background: white;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};

  @media (max-width: 768px) {
    height: 56px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    height: 48px;
  }
`
const RadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 35px;
  flex: 1;
  border-right: 1px solid #d5d8db;

  @media (max-width: 768px) {
    height: 30px;
    max-width: none;
  }

  @media (max-width: 480px) {
    height: 28px;
  }
`
const MaleFemale = styled.span`
  color: ${(props) => props.theme.colors.text.inputPlaceholder};
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  cursor: pointer;
`
const GenderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 39px;
  width: 100%;
`
const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  ${"" /* max-width: 250px; */}
  width: 100%;
`

// <RadioWrapper>
//           <CleanRadio onChange={() => handleRadio('male')} tabIndex="4" checked={radio1Checked} label="M" />
//           <CleanRadio onChange={() => handleRadio('female')} tabIndex="5" checked={radio2Checked} label="F" />
//         </RadioWrapper>

const GenderAndDateInput = ({
  radio1Checked,
  radio2Checked,
  handleRadio,
  handleDOB,
  DOBString,
  // handleDOBKeyDown,
  error,
}) => {
  return (
    <>
      <OuterWrapper error={error}>
        <RadioWrapper>
          <GenderWrapper
            onClick={() => handleRadio("male")}
            onKeyDown={({ key }) =>
              key === "Enter" ? handleRadio("male") : null
            }
          >
            <RadioLabel checked={radio1Checked}>
              <RadioInput />
            </RadioLabel>
            <MaleFemale>M</MaleFemale>
          </GenderWrapper>
          <GenderWrapper
            onClick={() => handleRadio("female")}
            onKeyDown={({ key }) =>
              key === "Enter" ? handleRadio("female") : null
            }
          >
            <RadioLabel checked={radio2Checked}>
              <RadioInput />
            </RadioLabel>
            <MaleFemale>F</MaleFemale>
          </GenderWrapper>
        </RadioWrapper>
        <DateWrapper>
          <Input
            placeholder="MM/DD/YYYY"
            onChange={handleDOB}
            value={DOBString}
            // onKeyDown={handleDOBKeyDown}
            type="tel"
          />
        </DateWrapper>
      </OuterWrapper>
      <FormError error={error} />
    </>
  )
}

export default GenderAndDateInput
